/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
// import moment from "moment";

import ScrollMenu from 'react-horizontal-scrolling-menu';
import ContentItemWide from '../../components/ContentItemWide';

class DateLine extends Component {
  state = {
    mouseOn: false,
  };
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;
    this._getData();
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };

  _getData = async () => {
    const { contentSerial } = this.props.childProps;

    if (
      contentSerial === '' ||
      contentSerial === null ||
      contentSerial === undefined
    ) {
      alert('잘못된 경로 또는 URL입니다.');
    } else {
      const result = await this._getDataApi();
      const intReturn = result.data[0].intReturn;
      const contentPartList = result.data[0].listData;

      if (intReturn === 0) {
        if (this._isMounted) {
          this.setState({
            contentPartList,
          });
        }
      }
    }
  };

  _getDataApi = () => {
    const { apiUrl, loginId, pkg } = this.props;
    const { contentSerial } = this.props.childProps;
    ////console.log(apiUrl + '/itemInfo?contentSerial=' + contentSerial)
    let userid;
    if (loginId === null || loginId === undefined || loginId === '') {
      userid = '';
    } else {
      userid = loginId;
    }
    return axios(
      apiUrl +
        '/itemPartNew?contentSerial=' +
        contentSerial +
        '&userid=' +
        userid +
        '&pkg=' +
        pkg
    )
      .then((response) => response)
      .catch((error) => {
        alert('화별 데이터를 로드 중 오류가 발생했습니다.');
      });
  };

  _renderItem = () => {
    const { contentPartList } = this.state;
    const { playToggle, liveStop } = this.props.childProps;
    //console.log(contentPartList)
    const list = contentPartList.map((item, index) => {
      return (
        <div key={index}>
          <ContentItemWide
            refer={'part'}
            title={item.title}
            subTitle={item.subTitle}
            img={item.img}
            overImg={item.overImg}
            contentSerial={item.contentSerial}
            contentPartSerial={item.contentPartSerial}
            subPartSerial2={item.subPartSerial2}
            subPartSerial3={item.subPartSerial3}
            lastContentPartSerial={item.lastContentPartSerial}
            pos={item.pos}
            mediaTime={'00:00:00'}
            dRank={item.dRank}
            opening={item.opening}
            playToggle={playToggle}
            liveStop={liveStop}
          />
        </div>
      );
    });

    return list;
  };
  _arrowNext = () => {
    const { slideIndex, contentPartList } = this.state;
    const cnt = contentPartList.length;
    const page = parseInt(cnt / 6);

    if (slideIndex < page) {
      this.setState({
        slideIndex: slideIndex + 1,
      });
    }
  };
  _arrowPrev = () => {
    const { slideIndex } = this.state;
    // const cnt = contentPartList.length;
    // const page = parseInt(cnt / 6);

    if (slideIndex < 1) {
      this.setState({
        slideIndex: slideIndex - 1,
      });
    }
  };
  _renderDot = () => {
    const { slideIndex, contentPartList } = this.state;
    const cnt = contentPartList.length;
    let page = parseInt(cnt / 6);
    if (page === 0) {
      page = 1;
    }
    let arr = [];

    for (let i = 1; i <= page; i++) {
      arr.push(<em key={i} className={i === slideIndex ? 'on' : null}></em>);
    }
    const list = arr.map((item) => {
      return item;
    });
    ////console.log()
    return list;
  };
  _onToggleMouseOn = () => {
    //const { mouseOn } = this.state;

    this.setState({
      mouseOn: true,
    });
  };
  _onToggleMouseOff = () => {
    //const { mouseOn } = this.state;

    this.setState({
      mouseOn: false,
    });
  };
  _onItem = () => {
    const { setContentSerial } = this.props;
    const { contentSerial } = this.props.childProps;
    setContentSerial(contentSerial);
  };
  render() {
    const { contentPartList, mouseOn } = this.state;
    //console.log(contentPartList)
    return (
      <Fragment>
        {contentPartList ? (
          <div className="main_list_style">
            <h1>
              <strong>
                {contentPartList[0].title === '' ||
                contentPartList[0].title === null ||
                contentPartList[0].title === undefined
                  ? null
                  : contentPartList[0].title}{' '}
                다시보기
              </strong>
              <div>
                <em className="on"></em>
                <em></em>
                <em></em>
                <a style={{ cursor: 'pointer' }} onClick={this._onItem}>
                  더보기
                </a>
              </div>
            </h1>
            <div
              className="main_list_goup1"
              style={{ width: '100%' }}
              onMouseEnter={this._onToggleMouseOn}
              onMouseLeave={this._onToggleMouseOff}
            >
              <div className="div_ul" style={{ marginTop: -45 }}>
                <ScrollMenu
                  data={contentPartList ? this._renderItem() : null}
                  arrowLeft={
                    mouseOn ? (
                      <a
                        className="left_btn"
                        style={{ cursor: 'pointer' }}
                        onClick={this._arrowPrev}
                      >
                        <span className={'on'}>이전</span>
                      </a>
                    ) : null
                  }
                  arrowRight={
                    mouseOn ? (
                      <a
                        className="right_btn"
                        style={{ cursor: 'pointer' }}
                        onClick={this._arrowNext}
                      >
                        <span className={'on'}>다음</span>
                      </a>
                    ) : null
                  }
                  wheel={false}
                  dragging={true}
                  transition={0.5}
                  translate={2}
                  alignOnResize={true}
                  //inertiaScrolling={true}
                  //inertiaScrollingSlowdown={3}
                  //wrapperStyle={{border: 0, backgroundColor: '#000'}}
                  alignCenter={false}
                  hideSingleArrow={true}
                  hideArrows={mouseOn}
                  onUpdate={(t) => {}}
                  //innerWrapperStyle={{textAlign: 'center'}}
                  //onSelect={this._onSelect}
                  //selected={selected}
                />

                {/*
                                <div className="div_li">
                                    <em><img src="/img/top10.png"/></em>
                                    <div className="list_img_bg"><img src="/img/test_img5.png"/></div>
                                    <p>카구야님은 고백받고 싶어 ~ <span>제2화. 녀석들이 미워</span></p>
                                </div>
                                <div className="div_li">
                                    <div className="list_img_bg"><img src="/img/test_img5.png"/></div>
                                    <p>카구야님은 고백받고 싶어 ~ <span>제2화. 녀석들이 미워</span></p>
                                </div>
                                */}
              </div>
              <div className="clear"></div>
            </div>
          </div>
        ) : null}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(DateLine));
